<template>
    <div class="containertable" style="display: flex">
      <v-progress-linear v-if="loadingActive" color="#2A5377" style="width: 100%; margin-left: 50px; margin-right: 50px;"
          indeterminate>
      </v-progress-linear>      
      <md-card v-else style="margin: 20px; display: flex; flex-direction: column;">
        <div v-if="notifARR.length != 0">
            <h3 class="rs-data-title">Alcance</h3>
            <div :style="'display: flex; flex-direction: row; justify-content: space-around;'">
            <div :style="'display: flex; flex-direction: row'">
                <h4 class="rs-data-title">Liberados:</h4>
                <h4 class="rs-data-title">{{notifARR.length}}</h4>
            </div>
            <!--<div :style="'display: flex; flex-direction: row'">
                <h4 class="rs-data-title">Pendentes: </h4>
                <h4 class="rs-data-title">{{notifARR.filter((e) => {return e.VERSAOATUAL != versao.VERVERSAOSETUP }).length}}</h4>
            </div>-->
            <div :style="'display: flex; flex-direction: row'">
                <h4 class="rs-data-title">Recebidos: </h4>
                <h4 class="rs-data-title">{{notifARR.filter((e) => {return e.RECEBIDO }).length}}</h4>
            </div>
            <div :style="'display: flex; flex-direction: row'">
                <h4 class="rs-data-title">Lidos: </h4>
                <h4 class="rs-data-title">{{notifARR.filter((e) => {return e.VISUALIZADO }).length}}</h4>
            </div>
            <div :style="'display: flex; flex-direction: row'">
                <h4 class="rs-data-title">Fechados: </h4>
                <h4 class="rs-data-title">{{notifARR.filter((e) => {return e.FECHADO }).length}}</h4>
            </div>
            </div>
            <div style="margin: 10px;">
            <v-progress-linear color="#66cc66" background-color="#dddddd" :value="notifARR.filter((e) => {return e.RECEBIDO }).length / notifARR.length * 100" style="width: 90%; margin-left: 50px; margin-right: 50px; position: absolute;" />
            <v-progress-linear color="#6699ff" background-color="#dddddd" :value="notifARR.filter((e) => {return e.VISUALIZADO }).length / notifARR.length * 100" style="width: 90%; margin-left: 50px; margin-right: 50px; position: absolute;" />
            </div>
            <v-data-table
            dense
            hide-actions
            :headers="headers"
            class="elevation-1"
            :items="notifARR"
            item-key="CLICODIGO"
            style="margin-top: 40px; padding-bottom: 20px;"
            no-results-text="Nada foi encontrado."
            >
            <template v-slot:items="props">
                <tr>
                <td>{{props.item.CLINOMEUSUAL}}</td>
                <td>{{props.item.FECHADO ? "Fechado" : props.item.VISUALIZADO ? "Visualizado" : props.item.RECEBIDO ? "Recebido" : "Pendente"}}</td>
                <td>{{props.item.COUNTUSUARIOS}}</td>
                <td>{{props.item.RECEBIDO | formatDateNormal}}</td>
                <td>{{props.item.VISUALIZADO | formatDateNormal}}</td>
                <td>{{props.item.FECHADO | formatDateNormal}}</td>
                </tr>
            </template>

            <template v-slot:expand="props">
            </template>
            </v-data-table>  
        </div>
    </md-card>
  </div>
</template>
<script>

import * as Notificacoes from "../../providers/notificacoes.service";

export default {
  props: ["NOTCONTADOR"],
  data() {
    return {
      //notifDados: null,
      notifARR: [],
      loadingActive: true,
        headers: [
          {
            text: "Cliente",
            value: "CLINOMEUSUAL"
          },
          {
            text: "Situação",
            value: "SITUACAO"
          },
          {
            text: "Usuários",
            value: "COUNTUSUARIOS"
          },
          {
            text: "Recepção",
            value: "RECEBIDO"
          },
          {
            text: "Visualização",
            value: "VISUALIZADO"
          },
          {
            text: "Fechamento",
            value: "FECHADO"
          }
        ]
    };
  },
  created() {
    debugger;
    this.getLiberados();
  },
  methods: {
    getLiberados() {
      var self = this;

      //Notificacoes.getNotificacoesResumo(self.NOTCONTADOR ).then(r => notifDados = r);

      Notificacoes.getNotificacoesDetalhe(self.NOTCONTADOR ).then(r => {
        self.notifARR = r;
        self.loadingActive = false;
      });
    }
  }
};
</script>
<style scoped>
table {
  width: 100%;
}

td,
th {
  border: 1px solid rgb(233, 233, 233);
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #CFDFE5;
}

.subtitle-2 {
  min-height: 30px;
}
.overlayy {
  z-index: 10;
  background: rgba(0, 0, 0, 0.39);
  position: absolute;
  width: 100%;
  height: 99%;
  top: 0;
  border-radius: 5px;
  left: 0;
}
li {
  min-height: 58px;
}

span,
div,
table,
td,
tr,
th {
  transition: all 0.3s ease !important;
}

/*.md-theme-default a:not(.md-button) {
  color: #2b5577 !important;
}*/

.md-theme-default a:hover {
  color: #00aaff !important;
  text-decoration: underline !important;
}

table.v-table tbody td, table.v-table tbody th{
  height: 25px;
}

.rs-data-title{
  display: flex;
  justify-content: center;
}

.rs-priority-icon{
  margin-right: 10px;
  font-size: 20px !important;
}

</style>